import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { PromoPopup } from "@/components/site/PromoPopup";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Board from "@/pages/Board";
import Tryouts from "@/pages/Tryouts";
import Teams from "@/pages/Teams";
import TeamDetail from "@/pages/TeamDetail";
import Athletes from "@/pages/Athletes";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Media from "@/pages/Media";
import ArticleDetail from "@/pages/ArticleDetail";
import Sponsors from "@/pages/Sponsors";
import Parents from "@/pages/Parents";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Portal from "@/pages/Portal";
import Admin from "@/pages/Admin";

const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <PromoPopup />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/board" element={<Board />} />
              <Route path="/tryouts" element={<Tryouts />} />
              <Route path="/teams" element={<Teams />} />
              <Route path="/teams/:slug" element={<TeamDetail />} />
              <Route path="/athletes" element={<Athletes />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:slug" element={<EventDetail />} />
              <Route path="/media" element={<Media />} />
              <Route path="/media/:id" element={<ArticleDetail />} />
              <Route path="/sponsors" element={<Sponsors />} />
              <Route path="/parents" element={<Parents />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/login" element={<Login />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/portal" element={<Portal />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;
